// MediaSidebarDataTuwe.js
import {
  FaHome,
  FaInfoCircle,
  FaHandsHelping,
  FaUsers,
  FaEnvelope,
  FaDonate
} from "react-icons/fa";

export const MediaSidebarData = [
  {
    title: "Home",
    icon: FaHome,
    path: "/",
  },
  {
    title: "About Us",
    icon: FaInfoCircle,
    path: "/#about-us",
 
  },
  {
    title: "Programs",
    icon: FaHandsHelping,
    path: "/#programs",
  },
  {
    title: "Join Us",
    icon: FaUsers,
    path: "/#join-us",
  },
  {
    title: "Contact",
    icon: FaEnvelope,
    path: "/#contact",
  },
  {
    title: "Donate",
    icon: FaDonate,
    path: "/donate",
  },
];
